import type { Row } from '@tanstack/react-table';
import type { MouseEvent } from 'react';

export const toggleClaimRowFromClick = (
  event: Pick<MouseEvent, 'target' | 'defaultPrevented'>,
  row: Pick<Row<unknown>, 'getCanExpand' | 'toggleExpanded'>
): void => {
  if (
    event.defaultPrevented ||
    !row.getCanExpand() ||
    !(event.target instanceof Element) ||
    event.target.closest(
      'button, a, input, select, textarea, label, [role="button"], [role="checkbox"], [role="menuitem"], [contenteditable="true"]'
    )
  ) {
    return;
  }

  row.toggleExpanded();
};
